import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProfileImg from "./../../../assets/images/profileImage.jpg";
import "video-react/dist/video-react.css";
import { Player } from "video-react";
import { AiOutlineClockCircle } from "react-icons/ai";
import { SideMenu, BackHeader } from "./../../components";
import { useNavigate } from "react-router-dom";
const MyCourseLive = () => {
  const navigate = useNavigate();
  const TotalStudentList = [
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
    { name: "Samantha aryton" },
  ];
  return (
    <SideMenu>
      <div className="my-classes-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
              <div className="video-section-main">
                <BackHeader backHanler={() => navigate(-1)} />
                <Player
                  className="play"
                  playsInline
                  poster={ProfileImg}
                  src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4"
                />
                <div className="video-section-header-main">
                  <p className="video-section-header-heading">Maths Class</p>
                  <div className="video-section-header-date-main">
                    <AiOutlineClockCircle color="#303030" />
                    <p className="video-section-header-date">
                      JAN 31, 2022, 10:30 AM
                    </p>
                  </div>
                </div>
                <p className="video-description">
                  Quisque a fringilla nisi, nec suscipit justo. Pellentesque
                  habitant morbi tristique senectus et netus et malesuada fames
                  ac turpis egestas. Fusce nulla odio, mattis vel nibh eget,
                  suscipit laoreet libero.
                </p>
                <p className="video-section-user-heading">instructor</p>
                <div
                  className="video-section-user-profile-main"
                  style={{ border: "none" }}
                >
                  <div className="video-section-user-data-container">
                    <img
                      src={ProfileImg}
                      className="video-section-user-profile-image"
                    />
                    <div>
                      <p className="video-section-user-name">David anderson</p>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div className="video-right-section-main">
                <p className="video-right-section-heading">Students</p>
                {TotalStudentList.map((v, i) => {
                  return (
                    <div className="video-right-section-list-main">
                      <img
                        src={ProfileImg}
                        className="video-right-section-list-profile-image"
                      />
                      <p className="video-right-section-list-username">
                        {v.name}
                      </p>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default MyCourseLive;
